<template>
  <div class="link-container">
    <!--1.头部-->
    <header-frame></header-frame>

    <!--外联管理-->
    <van-tabs :border="true" v-model="activeIndex" :ellipsis="false" :swipe-threshold="4">
      <van-tab v-for="(item, index) in linkList" :key="index" :title="item.name">
        <p
          v-for="(value, key) in item.linkInfoList"
          @click="jumpRouter(value.linkUrl)"
          :key="'link' + key"
        >
          <span>{{ value.name }}</span>
        </p>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import codes from '@/api/codes';
import HeaderFrame from '@/components/Header';

export default {
  name: 'index',
  components: {
    HeaderFrame,
  },
  data() {
    return {
      linkList: [], // 外链
      activeIndex: 0,
    };
  },
  mounted() {
    this.initLinksInfo();
  },
  methods: {
    // 获取所有外链信息
    initLinksInfo() {
      let replacement = {
        subjectId: codes.SUBJECT_ID,
      };
      this.$api.getLinksInfo(replacement).then((data) => {
        this.linkList = data;
        this.activeIndex = parseInt(1, 10) - 1;
      });
    },

    // 路由跳转
    jumpRouter(url) {
      if (url) {
        window.open(url);
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/common.scss';

.link-container {
  header {
    top: 0;
    position: absolute;
    z-index: 999;
    box-shadow: 0px calc-width(3vw) calc-width(10vw) rgba(0, 0, 0, 0.07);
  }

  .van-tabs__wrap--scrollable .van-tabs__nav {
    padding-left: calc-width(15vw);
  }

  .van-tabs.van-tabs--line {
    padding-top: calc-width(55vw);
  }

  .van-tabs--line .van-tabs__wrap {
    height: calc-width(55vw);
  }

  .van-tabs__line {
    display: none;
  }

  .van-tab {
    font-size: calc-width(14vw);
    font-family: SourceHanSansCN-Medium;
    font-weight: 600;
    color: rgba(179, 179, 179, 1);
    box-sizing: border-box;
    /*width: 33.3333%;*/
    line-height: calc-width(55vw);
    padding: 0;
    margin-right: calc-width(15vw);
    text-align: center !important;
  }

  .van-tab.van-tab--active {
    color: $primary-color;
    box-sizing: border-box;
    border-bottom: calc-width(3vw) solid $primary-color;
  }

  .van-tabs {
    /*margin-top: 3px;*/

    .van-tab {
      font-size: calc-width(14vw);
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      color: #333333;
      text-align: center;
    }
  }

  p {
    padding: 0 calc-width(15vw);
    margin-top: calc-width(25vw);
    font-size: calc-width(15vw);
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    color: #333;

    span {
      width: 100%;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/link/index.vue